import { render, staticRenderFns } from "./TableHead.vue?vue&type=template&id=80b0a894&scoped=true"
var script = {}
import style0 from "./TableHead.vue?vue&type=style&index=0&id=80b0a894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b0a894",
  null
  
)

export default component.exports